import type * as React from 'react';
const SvgIcoTextFields = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 4.5v3h5v12h3v-12h5v-3zm19 5h-9v3h3v7h3v-7h3z" fill="currentColor" />
  </svg>
);
export default SvgIcoTextFields;
